import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "$3875 February sidehustle report",
  "description": "",
  "published": "2017-03-07T00:00:00.000Z",
  "redirect_from": ["/blog/february-sidehustle-report/swizec/7471"],
  "categories": "Business, Side Projects, sidehustle",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`About $3840 revenue in February. Not bad for a sidehustle 🤔`}<br parentName="p"></br><br parentName="p"></br>{`Would anyone be interested in monthly biz updates?`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/837415105004363776"
      }}>{`March 2, 2017`}</a></blockquote>
    <p>{`People have been asking how I sidehustle, what makes it work, and whether when the sums are up, if it's worth the time. Would I not be better off just getting a better paying job?`}</p>
    <p>{`If that job was as a fancy pants senior engineer at Facebook… probably, yeah. But what's the fun in that? 3 hours commuting every day.`}</p>
    <p>{`So here's the breakdown for February 2017 ?`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/gumroad-screenshot.png",
        "alt": null
      }}></img></p>
    <p><strong parentName="p">{`Total revenue:`}</strong>{` $3,875`}</p>
    <p><strong parentName="p">{`Gumroad sales:`}</strong></p>
    <ul>
      <li parentName="ul">{`ES6 Cheatsheet: $30 -fees`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`React+D3v4 preorders: $1,029 -fees`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`React+D3 ES6: $848 -fees`}</li>
    </ul>
    <p><strong parentName="p">{`Leanpub sales:`}</strong>{` $255`}</p>
    <ul>
      <li parentName="ul">{`Why Programmers Work at Night: $8.5`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`React+D3js: $69`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`React+D3 ES6: $177`}</li>
    </ul>
    <p><strong parentName="p">{`React Native School:`}</strong>{` $1,840`}</p>
    <p><strong parentName="p">{`Time investment:`}</strong>{` 46 hours`}</p>
    <p><strong parentName="p">{`Cost:`}</strong>{` $2,382`}</p>
    <ul>
      <li parentName="ul">{`AppSumo: $99`}</li>
      <li parentName="ul">{`Editor: $550`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`VA: $349`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`Camtasia Upgrade: $120`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`DSLR to improve videos: $800`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`Studio lighting + mic arm: $160`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`Drip: $184`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`Hosting: $10`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`LiveEdu pro account: $10`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`Facebook ads: $100`}</li>
    </ul>
    <p><strong parentName="p">{`Output:`}</strong></p>
    <ul>
      <li parentName="ul">{`2 React Native lectures`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`3+ Livecoding sessions`}</li>
      <li parentName="ul"></li>
      <li parentName="ul">{`7 blog posts`}</li>
      <li parentName="ul"></li>
      <li parentName="ul"><em parentName="li">{`some`}</em>{` React+D3v4 progress on the animation chapter`}</li>
    </ul>
    <p>{`This has been an expensive month. ? I've decided to go hard on video, and I wasn't happy with the quality. You can see a big improvement just with studio lighting.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/swizec-without-lighting.png",
        "alt": null
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/swizec-with-lighting.png",
        "alt": null
      }}></img></p>
    <p>{`Bottom left corner. See how much better I look with a good light? Yes, magnificent screenshot to show this off, I know. ?`}</p>
    <p><strong parentName="p">{`Net hourly rate:`}</strong>{` $32 pre-tax`}</p>
    <p>{`Not `}<em parentName="p">{`too`}</em>{` bad, gotta work on my unit economics ?`}</p>
    <p>{`…and find time to update the `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js"
      }}>{`React+D3`}</a>{` landing page. It's still selling the old stuff LOL.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      